import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';
import localization from '../../../shared/strings';
import * as utils from '../../../shared/utils';

/**
 * Make SavedSearches tree from list
 * @param {Object[]} savedSearchesTree
 * @param {string} userId
 * @param {string?} searchQuery
 * @returns {Object}
 */
export default function makeTree(items, userId, searchQuery = '') {
  const list = items.map((svdSearch) => ({ ...svdSearch }));
  const tree = {
    favorites: {
      name: localization.SAVEDSEARCHESTREE.textFavorites,
      path: 'favorites',
      root: true,
      isOpen:
				utils.getCookie('picsio.savedSearchedTree.favorites.open') === null
				|| utils.getCookie('picsio.savedSearchedTree.favorites.open'),
      nodes: [],
    },
    teamSearches: {
      name: localization.SAVEDSEARCHESTREE.textTeamSearches,
      path: 'teamSearches',
      root: true,
      isOpen:
				utils.getCookie('picsio.savedSearchedTree.teamSearches.open') === null
				|| utils.getCookie('picsio.savedSearchedTree.teamSearches.open'),
      nodes: [],
    },
    personalSearches: {
      name: localization.SAVEDSEARCHESTREE.textSavedSearches,
      path: 'savedSearches',
      root: true,
      isOpen:
				utils.getCookie('picsio.savedSearchedTree.savedSearches.open') === null
				|| utils.getCookie('picsio.savedSearchedTree.savedSearches.open'),
      nodes: [],
    },
  };

  list.forEach((svdSearch) => {
    /** path can be undefined */
    /** @type {string[] | undefined} */
    const pathArr = svdSearch?.path?.split(NEW_PATH_DELIMITER);

    if (!pathArr) {
      /** if just name */
      if (searchQuery && !svdSearch.name.toLowerCase().includes(searchQuery.toLowerCase())) {
        return;
      }
      if (svdSearch.teamId) {
        tree.teamSearches.nodes.push(svdSearch);
      } else {
        tree.personalSearches.nodes.push(svdSearch);
      }
      return;
    }

    pathArr.shift(); // remove first element (empty string)

    const add = (path, nodes) => {
      const name = path.shift();
      const found = nodes.find((node) => node.name === name && node.isGroup);
      if (found) {
        if (path.length === 0) {
          found.nodes.push(svdSearch);
        } else {
          add(path, found.nodes);
        }
      } else if (path.length === 0) {
        nodes.push(svdSearch);
      } else {
        const groupPath = svdSearch.path.split(NEW_PATH_DELIMITER).slice(0, -path.length).join(NEW_PATH_DELIMITER);
        const newNode = {
          _id: groupPath,
          name,
          path: groupPath,
          isGroup: true,
          readonly: svdSearch.readonly,
          dynamic: svdSearch.dynamic,
          teamId: svdSearch.teamId,
          nodes: [],
        };
        nodes.push(newNode);
        add(path, newNode.nodes);
      }
    };

    if (searchQuery) {
      if (svdSearch.name.toLowerCase().includes(searchQuery.toLowerCase())) {
        if (svdSearch.teamId) {
          tree.teamSearches.nodes.push(svdSearch);
        } else {
          tree.personalSearches.nodes.push(svdSearch);
        }
      }
    } else if (svdSearch.teamId) {
      add(pathArr, tree.teamSearches.nodes);
    } else {
      add(pathArr, tree.personalSearches.nodes);
    }
  });

  tree.favorites.nodes = list.filter(
    (node) => {
      if (searchQuery && !node.name.toLowerCase().includes(searchQuery.toLowerCase())) {
        return false;
      }
      return node.favorites?.length && node.favorites.includes(userId);
    },
  );

  return tree;
}
